// https://stackoverflow.com/questions/62210286/declare-type-with-react-useimperativehandle
// https://github.com/jaredpalmer/formik/issues/1603#issuecomment-575669249

import { Stack } from "@chakra-ui/react";
import { Form as FormikForm, Formik, FormikHelpers } from "formik";
import React from "react";
import * as Yup from "yup";
import { FormInputControl } from "../../../components/forms";
import {
  ICohort,
  ICohortCreate,
  ICohortWorkingForm,
  initialCohortWorkingForm,
} from "../../registries/models/Cohort";

export type FormHandle = {
  submitForm: () => void;
};

interface IProps {
  cohort?: ICohort;
  onSubmit: (data: ICohortCreate) => Promise<void>;
}

export const CohortForm = React.forwardRef<FormHandle, IProps>(
  ({ onSubmit, cohort }, ref) => {
    React.useImperativeHandle(ref, () => ({
      // start() has type inferrence here
      submitForm() {
        bagRef.current.submitForm();
      },
    }));

    const bagRef = React.useRef<any>();

    const [workingFormValues, set_workingFormValues] =
      React.useState<ICohortWorkingForm>(initialCohortWorkingForm);

    const CohortFormsSchema = Yup.object().shape({
      title: Yup.string().required("Name is required"),
      description: Yup.string().required("Description is required"),
    });

    const handleOnSubmit = async (
      values,
      actions: FormikHelpers<ICohortWorkingForm>
    ) => {
      actions.setStatus();
      actions.setSubmitting(true);

      const createCohort: ICohortCreate = {
        ...values,
      };

      try {
        // Pass up logic
        await onSubmit(createCohort);
      } catch (error) {
        // Error submitting form, set status for dispaly
        actions.setStatus("Failed to update message. Please try again.");
      }

      actions.setSubmitting(false);
    };

    React.useEffect(() => {
      if (cohort) {
        const workingFormValuesUpdate = { ...cohort };

        if (!workingFormValuesUpdate.description) {
          workingFormValuesUpdate.description = "";
        }

        set_workingFormValues(workingFormValuesUpdate);
      }
    }, [cohort]);

    return (
      <Formik
        innerRef={bagRef}
        initialValues={workingFormValues}
        validationSchema={CohortFormsSchema}
        onSubmit={(values, actions) => {
          handleOnSubmit(values, actions);
        }}
        enableReinitialize={true}
      >
        {(props) => {
          return (
            <FormikForm>
              <Stack spacing={6}>
                <FormInputControl
                  label={"Cohort Name"}
                  name="title"
                  formControlProps={{
                    maxW: "28rem",
                  }}
                />
                <FormInputControl label={"Description"} name="description" />
              </Stack>
            </FormikForm>
          );
        }}
      </Formik>
    );
  }
);
